import { useMutation } from "@tanstack/react-query";
import { loginSuperAdmin } from "services/superAdminAuth";
import { useSuperAdminAuthStore } from "store/superAdminAuth";

export const useLoginSuperAdmin = () => {
  const setSuperAdminAuthData = useSuperAdminAuthStore(
    (state) => state.setSuperAdminAuthData
  );

  const query = useMutation({
    mutationKey: ["login-super-admin"],
    mutationFn: (data) => loginSuperAdmin(data),
    onSuccess: (data) => {
      setSuperAdminAuthData(data);
    },
  });

  return query;
};

